export function emailValidation(email) {
    const emailRegex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return emailRegex.test(email);
}

export function mobileValidation(mobile) {
    const regexs = [
        /^(?:(?:(?:\+33|\+41|\+352|\+590))[6-7])(?:\d{8})$/,
        /^(?:(?:(?:0))[6-7])(?:\d{8})$/,
        /^(?:(?:(?:\+351))[9][01236])(?:\d{7})$/,
        /^(?:(?:\+1))(?:\d{10})$/,
        /^(?:(?:\+8869))(?:\d{8})$/,
        /^(?:(?:(?:\+32))[4])(?:\d{8})$/,
        /^(?:(?:(?:\+962))[7])(?:\d{8})$/,
        /^(?:\+905)(?:\d{9})$/,
        /^(?:\+227)(?:\d{8})$/,
        /^(?:\+614)(?:\d{8})$/,
        /^(?:\+65)(?:\d{8})$/,
        /^(?:\+447)(?:\d{9})$/,
        /^(?:\+49)(?:\d{10})$/,
        /^(?:\+60)(?:\d{10})$/,
        /^(?:\+86)(?:\d{11})$/,
        /^(?:\+49)(?:\d{11})$/,
        /^(?:\+39)(?:\d{10})$/,
        /^(?:\+39)(?:\d{11})$/,
        /^(?:\+63)(?:\d{10})$/,
        /^(?:\+81)(?:\d{10})$/,
        /^(?:\+46)(?:\d{9})$/,
        /^(?:\+46)(?:\d{10})$/,
        /^(?:\+82)(?:\d{10})$/,
        /^(?:\+34)(?:\d{9})$/,
        /^(?:\+971)(?:\d{9})$/,
        /^(?:\+261)(?:\d{9})$/,
        /^(?:\+358)(?:\d{9})$/,
        /^(?:\+3538)(?:\d{8})$/,
        /^(?:\+316)(?:\d{8})$/,
        /^(?:\+593)(?:\d{9})$/,
        /^(?:\+237)(?:\d{8})$/,
        /^(?:\+376)(?:\d{8})$/,
        /^(?:\+377)(?:\d{8})$/,
        /^(?:\+594)(?:\d{9})$/,
        /^(?:\+596)(?:\d{9})$/,
        /^(?:\+262)(?:\d{9})$/,
        /^(?:\+687)(?:\d{6})$/,
        /^(?:\+689)(?:\d{8})$/,
        /^(?:\+508)(?:\d{6})$/,
        /^(?:\+681)(?:\d{6})$/,
        /^(?:\+974)(?:\d{8})$/,
        /^(?:\+226)(?:\d{8})$/,
        /^(?:\+852)(?:\d{8})$/,
        /^(?:\+40)(?:\d{9})$/
    ];

    return regexs.some((regex) => regex.test(mobile));
}